export default "__VITE_ASSET__CuOROL4o__"